import { ChevronDown, LayoutDashboard } from 'lucide-react';
import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall } from '../CommonComponents/CustomHooks';
import { GetSession } from '../CommonComponents/criptoUtils';
import { setOpen } from '../Redux/Services/headerSlice';

const Sidebar = () => {
    const [menus, setMenus] = useState([]);
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const dispatch = useDispatch();
    const { open } = useSelector((state) => state.header);
    const user = GetSession('cookies', 'user');

    //const getSidebar = async () => {
    //    //try {
    //    //    let res = await ApiCall(`/api/User/GetMenu`, {});
    //    //    if (res.status === 'SUCCESS') {
    //    //        setMenus(res.getMenu);
    //    //    } else if (res.status === "ERROR") {
    //    //        setMenus([]);
    //    //    } else if (res.status === 'EXPIRED') {
    //    //        await NotificationSound(res.status, res.message, res.focus);
    //    //    }
    //    //} catch (error) {
    //    //    console.error('Error fetching sidebar menu:', error);
    //    //    setMenus([]);
    //    //}
    //    setMenus([])
    //};

    const menuData = [
        {
            mSortNo: "1",
            mPageID: "0",
            cssClass: "fa fa-dashboard",
            menuText: "DASHBOARD",
            getSubMenu: [
                {
                    menuText: "Lead Dashboard",
                    folderName: "Dashboard",
                    pageUrl: "Dashboard/LeadDashboard",
                    pageID: "78",
                    mpageID: "1"
                }
            ]
        },
      
        {
            mSortNo: "4",
            mPageID: "0",
            cssClass: "fa fa-sign-in",
            menuText: "LEAD ENTRY",
            getSubMenu: [
                {
                    menuText: "Lead Entry",
                    folderName: "LeadEntry",
                    pageUrl: "LeadEntry/LeadEntry",
                    pageID: "30",
                    mpageID: "29"
                },
                {
                    menuText: "Pending FollowUp Lead",
                    folderName: "LeadEntry",
                    pageUrl: "LeadEntry/PendingFollowUpLead",
                    pageID: "32",
                    mpageID: "29"
                },
                {
                    menuText: "Reassign Lead",
                    folderName: "ReassignLead",
                    pageUrl: "LeadEntry/ReassignLead",
                    pageID: "33",
                    mpageID: "29"
                },
                {
                    menuText: "Lead Report",
                    folderName: "LeadEntry",
                    pageUrl: "LeadEntry/LeadEntryReport",
                    pageID: "31",
                    mpageID: "29"
                },
                {
                    menuText: "Log Report",
                    folderName: "LogReport",
                    pageUrl: "LeadEntry/LogReport",
                    pageID: "33",
                    mpageID: "29"
                },
            ]
        }
    ];

    const getSidebar = async () => {
        setMenus(menuData);
    };

    const handleSubmenuToggle = (menuIndex) => {
        const newIndex = activeSubmenu === menuIndex ? null : menuIndex;
        setActiveSubmenu(newIndex);

        if (newIndex) {
            localStorage.setItem("ACTIVE_SUBMENU", newIndex);
        }
    };

    useEffect(() => {
        const savedIndex = localStorage.getItem("ACTIVE_SUBMENU");
        if (savedIndex !== null) {
            setActiveSubmenu(Number(savedIndex));
        }
    }, []);

    useEffect(() => {
        getSidebar();
        function handleResize() {
            if (window.innerWidth < 1024) {
                dispatch(setOpen(false));
            } else {
                dispatch(setOpen(true));
            }
        }

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [dispatch]);


    //useEffect(() => {
    //    if (!user?.loginToken) {
    //        NotificationSound('EXPIRED', 'EXPIRED');
    //    }
    //}, [user]);

    return (
        <>
            {open && (
                <div
                    className="fixed inset-0 bg-black/50 z-30 lg:hidden"
                    onClick={() => dispatch(setOpen(false))}
                ></div>
            )}

            {/* Sidebar */}
            <aside
                className={`fixed top-16 left-0 h-[calc(100vh-4rem)] bg-white border-r border-gray-200 transition-all duration-300 z-40 shadow-xl ${open ? 'w-64' : 'w-0 lg:w-0'
                    } overflow-hidden`}
            >
                <div className="flex flex-col h-full">
                    {/* Menu Items */}
                    <div className="flex-1 overflow-y-auto p-3">
                        <ul className="space-y-1">
                            {menus.length > 0 ? (
                                menus.map((menu, index) => (
                                    <li key={index}>
                                        {menu.getSubMenu && menu.getSubMenu.length > 0 ? (
                                            <div>
                                                {/* Parent Menu with Submenu */}
                                                <button
                                                    onClick={() => handleSubmenuToggle(index)}
                                                    className={`w-full flex items-center justify-between px-2 py-1 text-[14px] rounded-lg transition-all ${activeSubmenu === index
                                                        ? 'bg-gradient-to-r from-[#1D4ED8] to-[#3B82F6] text-white shadow-md'
                                                        : 'hover:bg-gray-50 text-gray-700'
                                                        }`}
                                                >
                                                    <div className="flex items-center gap-2">
                                                        <div className='w-4'><i className={`${menu.cssClass}`} /></div>
                                                        <span className="font-medium ">{menu.menuText}</span>
                                                    </div>
                                                    <ChevronDown
                                                        size={20}
                                                        className={`transition-transform duration-200 ${activeSubmenu === index ? 'rotate-180' : ''
                                                            }`}
                                                    />
                                                </button>

                                                {/* Submenu */}
                                                <div
                                                    className={`overflow-y-auto bg-blue-100 rounded transition-all duration-300 ${activeSubmenu === index ? 'max-h-[250px] mt-1 py-1' : 'max-h-0'
                                                        }`}
                                                >
                                                    <div className="pl-2 space-y-1">
                                                        {menu.getSubMenu.map((subMenu, i) => (
                                                            <NavLink
                                                                key={i}
                                                                to={`/${subMenu.pageUrl}`}
                                                                onClick={() => {
                                                                    localStorage.setItem('ID', subMenu.mpageID);
                                                                    if (window.innerWidth < 1024) {
                                                                        dispatch(setOpen(false));
                                                                    }
                                                                }}
                                                                className={({ isActive }) =>
                                                                    `flex items-center gap-2 px-1 py-0.5 rounded-lg transition-all ${isActive
                                                                        ? 'text-[#3B82F6] text-[15px] fw-bold'
                                                                        : 'hover:bg-gray-100 text-[14px] text-gray-800'
                                                                    }`
                                                                }
                                                            >
                                                                <div className={`w-2 h-2 rounded-full bg-[#3B82F6]`}></div>
                                                                <span className=''>{subMenu.menuText.trim()}</span>
                                                            </NavLink>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            // Single Menu Item
                                            <NavLink
                                                to={`/${menu.pageUrl}`}
                                                onClick={() => {
                                                    if (window.innerWidth < 1024) {
                                                        dispatch(setOpen(false));
                                                    }
                                                }}
                                                className={({ isActive }) =>
                                                    `flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${isActive
                                                        ? 'bg-gradient-to-r from-redled-light to-redled-light text-white shadow-md'
                                                        : 'hover:bg-gray-50 text-gray-700'
                                                    }`
                                                }
                                            >
                                                <i className={`${menu.cssClass} text-lg`} />
                                                <span className="font-medium text-sm">{menu.menuText}</span>
                                            </NavLink>
                                        )}
                                    </li>
                                ))
                            ) : (
                                <li className="flex flex-col items-center justify-center py-12 text-gray-400">
                                    <LayoutDashboard size={48} className="mb-3" />
                                    <p className="text-sm">No menu items available</p>
                                </li>
                            )}
                        </ul>
                    </div>

                    {/* Footer */}
                    <div className="border-t border-gray-200 px-2 py-3 bg-gradient-to-r from-redled/1 to-redled-light/1">
                        <p className="text-xs text-gray-600 text-center">
                            Powered by{' '}
                            <Link
                                to="https://www.sagarinfotech.com/"
                                target='_blank'
                                className="text-[#3B82F6] hover:underline font-semibold"
                            >
                                Sagar Informatics Pvt. Ltd.
                            </Link>
                        </p>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default memo(Sidebar);